import React from 'react';
import { BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { useTheme } from '../../../hooks/useTheme';
import styles from './StackedBarChart.module.css';

interface StackedBarChartProps {
  data: any[];
  title: string;
  loading: boolean;
}

const StackedBarChart: React.FC<StackedBarChartProps> = ({ data, title, loading }) => {
  const theme = useTheme();
  
  console.log(`🔍 StackedBarChart ${title}:`, { data, loading, dataLength: data?.length });
  
  if (loading || !data || data.length === 0) {
    console.log(`⚠️ StackedBarChart ${title}: Sin datos o cargando`);
    return <div>Sin datos</div>;
  }

  const chartColors = theme.getChartColors(2);

  // Transformar y validar datos
  const transformedData = data
    .map(item => ({
      name: item.reason || item.name,
      value1: item.cambiar || item.value1 || 0,
      value2: item.devolver || item.value2 || 0,
      total: item.total || 0
    }))
    .filter(item => {
      // Filtrar valores NaN, null, undefined o negativos
      const isValid = !isNaN(item.value1) && !isNaN(item.value2) && 
                     item.value1 !== null && item.value2 !== null && 
                     item.value1 !== undefined && item.value2 !== undefined && 
                     item.value1 >= 0 && item.value2 >= 0 &&
                     isFinite(item.value1) && isFinite(item.value2);
      if (!isValid) {
        console.warn(`⚠️ Valor inválido filtrado en StackedBarChart:`, item);
      }
      return isValid;
    });

  console.log(`📊 StackedBarChart ${title} - transformedData:`, transformedData);
  
  if (transformedData.length === 0) {
    console.log(`⚠️ StackedBarChart ${title}: Sin datos válidos después de transformación`);
    return <div>Sin datos válidos</div>;
  }

  // Asegurar que todos los valores sean números válidos
  const sanitizedData = transformedData.map(item => ({
    ...item,
    value1: Math.max(0, Math.round(item.value1 * 100) / 100), // Permitir 0 en porcentajes
    value2: Math.max(0, Math.round(item.value2 * 100) / 100), // Permitir 0 en porcentajes
    total: Math.max(0, Math.round(item.total * 100) / 100) // Permitir 0 en porcentajes
  }));

  console.log(`🎨 StackedBarChart ${title} - renderizando con datos:`, sanitizedData);
  
  return (
    <div className={styles.chartContainer}>
      <ResponsiveContainer width="100%" height={250}>
        <RechartsBarChart data={sanitizedData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend 
            align="center"
            verticalAlign="bottom"
            layout="horizontal"
            formatter={(value, entry) => {
              if (entry.dataKey === 'value1') return 'Cambiar';
              if (entry.dataKey === 'value2') return 'Devolver';
              return value;
            }}
          />
          <Bar dataKey="value1" stackId="a" fill={chartColors[0]} />
          <Bar dataKey="value2" stackId="a" fill={chartColors[1]} />
        </RechartsBarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StackedBarChart;
